import { useMemo } from 'react';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { FetchError } from 'src/types/TApiQueries';
import {
  NotificationSettings,
  NotificationSettingsUpdatePayload,
} from 'src/types/TNotificationSettings';
import { updateNotificationSettings } from '../functions/notificationSettingsApi';
import { queryFnFetchErrorWrapper } from '../utils/errorHandlers';
import { queryNames } from '../utils/queryNames';

export function useUpdateNotificationSettingsMutation(
  mutationOptions?: UseMutationOptions<
    NotificationSettings,
    FetchError,
    NotificationSettingsUpdatePayload
  >,
) {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const mutationFn = useMemo(
    () =>
      queryFnFetchErrorWrapper((data: NotificationSettingsUpdatePayload) =>
        updateNotificationSettings(data, accessToken),
      ),
    [accessToken],
  );

  return useMutation(mutationFn, {
    ...mutationOptions,
    onSuccess: async (result, ...args) => {
      await queryClient.invalidateQueries([queryNames.notificationSettings]);
      mutationOptions?.onSuccess?.(result, ...args);
    },
  });
}
